import { render, staticRenderFns } from "./baozhuangjindu.vue?vue&type=template&id=02375bce&scoped=true&"
import script from "./baozhuangjindu.vue?vue&type=script&lang=js&"
export * from "./baozhuangjindu.vue?vue&type=script&lang=js&"
import style0 from "./baozhuangjindu.vue?vue&type=style&index=0&id=02375bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02375bce",
  null
  
)

export default component.exports